/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  errorMsgCms: [],
  quarter: '',
  displayObj: {
    quarter: '',
    quarterlyCms: [],
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ERROR_MSG_CMS:
      return { ...state, errorMsgCms: action.payload };
    case actionTypes.GET_FROM:
      let displayObj1 = {
        ...state.displayObj,
        quarter: action.payload,
      };
      return { ...state, quarter: action.payload, displayObj: displayObj1 };

    case actionTypes.GET_QUARTERLY_CMS:
      let displayObj = {
        ...state.displayObj,
        quarterlyCms: action.payload,
      };
      return { ...state, quarterlyCms: action.payload, displayObj };
    case actionTypes.SET_REFRESH_DATA_CMS:
      return {
        ...state,

        errorMsgCms: [],
        quarter: '',
      };
    case actionTypes.REFRESH_DATA_CMS_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
